import { CheckCircleOutlined } from '@mui/icons-material'
import { useTheme } from '@mui/material'
import Chip from '@mui/material/Chip'
import Typography from '@mui/material/Typography'
import { useFormikContext } from 'formik'

import useStyles from './index.styles'

const ActivationTypeChip = ({ label, value }: { label: string; value: 'replacement' | 'new' }) => {
  const classes = useStyles
  const theme = useTheme()
  const {
    values: { activationType },
    setFieldValue,
  } = useFormikContext<IFormValues>()

  return (
    <Chip
      label={<Typography variant="body1">{label}</Typography>}
      onClick={() => setFieldValue('activationType', value)}
      variant={activationType === value ? 'filled' : 'outlined'}
      icon={activationType === value ? <CheckCircleOutlined color="inherit" /> : undefined}
      color={activationType === value ? 'primary' : 'secondary'}
      sx={{ ...classes.activationTypeChip(theme), ...(activationType === value ? classes.activationTypeChipSelected(theme) : {}) }}
    />
  )
}

export default ActivationTypeChip
